/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemSeparator } from "./d-theme-white-menu-item-expandable-item-separator";

export class DThemeWhiteMenuSidedItemExpandableItemSeparator extends DThemeWhiteMenuItemExpandableItemSeparator {}
